import React, { useState, useRef } from "react";
import { Header } from "./components/Header";
import { Main } from "./components/Main";
import { SectionSolicita } from "./components/SectionSolicita";
import { Form } from "./components/Form";
import { Footer } from "./components/Footer";

export const App = () => {
  const [abrirModal, setAbrirModal] = useState(false);
  const [categoriaId, setCategoriaId] = useState("");
  const [categoriaNome, setCategoriaNome] = useState("");

  // Criar refs para todas as seções
  const headerRef = useRef(null);
  const mainRef = useRef(null);
  const solicitaRef = useRef(null);
  const formRef = useRef(null);

  return (
    <div>
      <Header currentRef={headerRef} nextRef={mainRef} />
      <Main currentRef={mainRef} nextRef={solicitaRef} scrollToSolicitaRef={solicitaRef} prevRef={headerRef} abrirModal={abrirModal} />
      <SectionSolicita currentRef={solicitaRef} nextRef={formRef} prevRef={mainRef} abrirModal={abrirModal} setAbrirModal={setAbrirModal} setCategoriaId={setCategoriaId} setCategoriaNome={setCategoriaNome} />
      <Form currentRef={formRef} prevRef={solicitaRef} abrirModal={abrirModal} setAbrirModal={setAbrirModal} categoriaId={categoriaId} categoriaNome={categoriaNome} />
      <Footer abrirModal={abrirModal} />
    </div>
  );
};

export default App;
